<template>
  <div>
    <!-- 产品增加 -->
    <!-- <el-dialog :title="operate === 'edit' ? '编辑产品' : '添加产品'" :close-on-click-modal="false"
      class="imgbox" width="800px" :append-to-body="true" :before-close="closeDialog"> -->
    <el-form label-width="110px" ref="ruleForm2" :rules="rules" :model="form">
      <el-form-item label="产品描述">
        <el-input type="textarea" resize="none" :rows="3" v-model="form.productDescription" :maxlength="255"
          show-word-limit></el-input>
      </el-form-item>

      <el-form-item label="离线提示语">
        <el-input type="textarea" resize="none" :rows="3" v-model="form.offlineInstructions" :maxlength="255"
          show-word-limit></el-input>
      </el-form-item>

      <div class="item-row">
        <div class="item-ele">
          <el-form-item label="接入类型" prop="accessType">
            <el-select v-model="form.accessType" placeholder="请选择接入类型" style="width: 100%;"
              :disabled="operate === 'edit'">
              <el-option v-for="item in accessTypeList" :key="item.key" :label="item.label" :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>


          
        </div>
        <div class="item-ele">
          

          <el-form-item label="产品别名">
            <el-input :maxlength="32" placeholder="请输入产品别名" v-model="form.aliases">
            </el-input>
          </el-form-item>
        </div>
        <div class="item-ele">
          
        </div>
      </div>

      <div class="item-row">
        <div class="item-ele">
          <el-form-item label="供应商" prop="manufacturerName">
            <el-input placeholder="请输入制造商" v-model="form.manufacturerName">
            </el-input>
          </el-form-item>
        </div>
        <div class="item-ele">
          <el-form-item label="供应商电话" prop="vendorPhone">
            <el-input placeholder="请输入供应商电话" v-model="form.vendorPhone">
            </el-input>
          </el-form-item>
        </div>
        <div class="item-ele">
          <el-form-item label="客服电话" prop="customerPhone">
            <el-input placeholder="请输入客服电话" v-model="form.customerPhone">
            </el-input>
          </el-form-item>
        </div>
      </div>

      <div class="item-row">
        <div class="item-ele">
          <el-form-item label="分组标签" prop="signGroup">
            <el-select :multiple="true" v-model="form.signGroup" placeholder="请选择分组标签" style="width: 100%;">
              <el-option v-for="item in tagOptions" :key="item.signId" :label="item.signDesc" :value="item.signId">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="item-ele">
          <el-form-item label="型号标签" prop="productModel">
            <el-input :disabled="operate === 'edit'" :maxlength="32" placeholder="请输入产品型号"
              v-model.trim="form.productModel">
            </el-input>
          </el-form-item>
        </div>
        <div class="item-ele">
          <el-form-item label="品牌标签" prop="productBrand">
            <el-select v-model="form.productBrand" placeholder="请选择产品品牌" style="width: 100%;"
              :disabled="operate === 'edit'">
              <el-option v-for="item in brandOptions" :key="item.brandId" :label="item.brandName" :value="item.brandId">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>

      <el-form-item label="协议文件" prop="agreementFile">
        <el-row>
          <el-col :span="20">
            <uploadFileView v-for="(item, index) in uploadFileList" :uploadFileList="uploadFileList" :item="item"
              :index="index" :key="item.id" />
          </el-col>
          <el-col :span="4">
            <div v-if="uploadFileList.length < 5" @click="addUploadFile" class="el-icon-plus avatar-uploader-icon" />
          </el-col>
        </el-row>
      </el-form-item>


    </el-form>
    <!-- <div slot="footer" class="dialog-footer" v-if="operate === 'edit'">
        <el-button type="primary" @click="nextStep('update')">修改</el-button>
      </div>
      <div v-else slot="footer" class="dialog-footer">
        <el-button @click="prevStep">上一步</el-button>
        <el-button type="primary" @click="nextStep">下一步</el-button>
      </div> -->
    <!-- </el-dialog> -->
    <ChooseTypeDrawe v-if="drawerFlag" :drawerFlag="drawerFlag" @closeDrawer="closeDrawer" @getData="receive" />
  </div>
</template>
<script>
import { addProduct, getGroupCategory, getBrand, editProduct } from '@/api/productRegistration'
import ChooseTypeDrawe from '@/components/product_control/chooseTypeDrawe'
import uploadFileView from '@/components/product_control/addProductDialog/uploadFileView'
import eventBus from '@/assets/js/eventBus'
import { REGEXP } from '@/assets/js/validator'
export default {
  props: {
    operate: {
      type: String
    },
    currentStep: {
      type: Number
    },
    expandDto: {
      type: Object
    },
    // brandOptions: {
    //   type: Array
    // },
    // tagOptions: {
    //   type: Array
    // },
    productDetail: {
      type: Object
    }
  },
  components: {
    ChooseTypeDrawe,
    uploadFileView
  },
  data() {
    // const inputFocus = (rule, value, callback) => {
    //   if (this.form.productModelType === 0 && this.form.categoryName === '') {
    //     callback(new Error('请选择类别'))
    //   } else {
    //     callback()
    //   }
    // }
    // const inputProductKey = (rule, value, callback) => {
    //   const reg = /^[A-Za-z0-9]+$/
    //   if (this.tag === 1) {
    //     if (this.form.productKey === '') {
    //       callback(new Error('产品标识不能为空'))
    //     } else if (this.form.productKey.length < 11) {
    //       callback(new Error('产品标识字符不得小于11'))
    //     } else if (this.form.productKey.length > 32) {
    //       callback(new Error('产品标识字符不得超过32个'))
    //     } else if (!reg.test(this.form.productKey)) {
    //       callback(new Error('产品标识只能由大小写字母，数字组成'))
    //     } else {
    //       callback()
    //     }
    //   } else {
    //     callback()
    //   }
    // }
    const validateCustomerPhone = (rule, value, callback) => {
      const num = this.form.customerPhone.trim()
      if (num === '') {
        callback()
      }
      if (!REGEXP.TELEPHONE_NUMBER.test(num)) {
        callback(new Error('电话格式为(区号-号码)或(区号-号码-分机)'))
      } else if (num.length > 20) {
        callback(new Error('客服电话长度不得超过20'))
      } else {
        callback()
      }
    }
    const validateVendorPhone = (rule, value, callback) => {
      const num = this.form.vendorPhone.trim()
      if (num === '') {
        callback()
      } else if (!REGEXP.TELEPHONE_NUMBER.test(num)) {
        callback(new Error('电话格式为(区号-号码)或(区号-号码-分机)'))
      } else if (num.length > 20) {
        callback(new Error('供应商电话长度不得超过20'))
      } else {
        callback()
      }
    }

    return {
      tag: 0,
      form: {
        productBrand: '', // 产品品牌 去掉 对应vendorId
        accessType: 0, // 接入类型
        productModel: '', // 产品型号 去掉 对应 vendorModelId
        signGroup: '', // 分组标签
        aliases: '', // 别名
        customerPhone: '', // 客服电话
        manufacturerName: '', // 制造商名称
        vendorPhone: '', // 供应商电话
        agreementFile: [], // 协议文件
        productDescription: '', // 描述
        offlineInstructions: '', // 离线提示语
        // configNet: ''// 配网方式
        // productName: '', // 产品名称
        // productKey: '', // 产品标识
        // productModelType: 1, // 产品品类
        // // categoryName: '', // 品类名称 不是必传 categoryKey必传
        // categoryParentId: '01d9609045b543619f1e389207e3636a', // 父级ID
        // categoryId: '818e95e5da4544cfa95bb802ed092178', // 子品类id
        // nodeType: '', // 节点类型
        // connectionType: '', // 连网方式
        // dataFormat: '', // 数据格式
        // authType: '', // 认证方式
        // isPrivate: 0, // 认证是否私有
        // productDescription: '', // 描述
        // customizeCategoryName: ''// 自定义品类名称
      },
      rules: {
        productModel: [
          { required: false, message: '请输入产品型号', trigger: 'blur' }
        ],
        productBrand: [
          { required: false, message: '请输入产品品牌', trigger: 'change' }
        ],
        accessType: [
          { required: true, message: '请选择接入类型', trigger: 'change' }
        ],
        // customerPhone: [
        //   { validator: validateCustomerPhone, trigger: ['blur', 'change'] }
        // ],
        customerPhone: [
          { message: '请输入客服电话', trigger: 'blur' },
          { validator: validateCustomerPhone, trigger: 'blur' }
        ],
        // configNet: [
        //   { required: true, message: '请选择配网方式', trigger: 'change' }
        // ],
        vendorPhone: [
          { validator: validateVendorPhone, trigger: 'blur' }
        ],
        manufacturerName: [
          { max: 20, message: '请输入20字以内的制造商名称', trigger: 'blur' }
        ]

        //
        // nodeType: [
        //   { required: true, message: '请选择节点类型', trigger: 'change' }
        // ],
        // connectionType: [
        //   { required: true, message: '请选择连网方式', trigger: 'change' }
        // ],
        // dataFormat: [
        //   { required: true, message: '请选择数据格式', trigger: 'change' }
        // ],
        // authType: [
        //   { required: true, message: '请选择认证方式', trigger: 'change' }
        // ],
        // isPrivate: [
        //   { required: true, message: '认证是否私有', trigger: 'change' }
        // ]
      },
      focusStatus: true,
      autosize: { minRows: 6 }, // 设置textarea的最小高度
      connectionTypeOptions: [
        {
          connectionTypeName: 'Wi-Fi',
          connectionTypeKey: 1
        },
        {
          connectionTypeName: 'Zigbee',
          connectionTypeKey: 2
        },
        {
          connectionTypeName: '蓝牙',
          connectionTypeKey: 3
        },
        {
          connectionTypeName: '蜂窝网(2G/3G/4G/5G)', // 蜂窝网ETHERNET
          connectionTypeKey: '4'
        },
        {
          connectionTypeName: '以太网',
          connectionTypeKey: '5'
        },
        {
          connectionTypeName: 'LiRaWAN',
          connectionTypeKey: '6'
        },
        {
          connectionTypeName: '其他',
          connectionTypeKey: '7'
        }
      ],
      authTypeOptions: [
        {
          authTypeName: '设备密钥',
          authTypeKey: 0
        },
        {
          authTypeName: 'X.509证书',
          authTypeKey: 1
        }
      ],
      drawerFlag: false, // 抽屉开关
      status: false,
      fileList: [],
      uploadFileList: [
        // {
        //   id: new Date().getTime() + Math.random(),
        //   fileList: [],
        //   validate: false,
        //   fileName: '',
        //   fileToken: '',
        //   fileDesc: '',
        //   businessType: 3// 业务类型(0:ios；1:安卓；2:中控面板；3:协议文件；4:其他)
        // }
      ],
      accessTypeList: [
        { key: 0, label: 'MQTT' },
        { key: 1, label: '云云对接' }
      ],
      configNetList: [
        { value: 0, label: '二维码' },
        { value: 1, label: '第三方SDK' },
        { value: 2, label: '本地SDK' }
      ],
      brandOptions: [],
      tagOptions: []
    }
  },
  created() {
    eventBus.$on('resetFields', this.resetFields);
    eventBus.$on('validateStep2', this.validateStep2);
    this.initStep2();
    if (this.operate === 'edit') {
      this.initData()
    }
  },
  watch: {
    tag: {
      handler(val) {
        if (val === 0) {
          console.log('不需要验证');
          this.status = false
        } else {
          this.status = true
        }
      }
    },
    // currentStep() {
    //   if (this.currentStep === 2) {
    //     // 获取品牌列表
    //     getBrand().then(res => {
    //       res = res.data
    //       if (res.code === 200) {
    //         const brandOptions = res.data.map(item => {
    //           return {
    //             brandName: item.commonName ? item.commonName : item.brandName,
    //             brandId: item.brandId ? item.brandId : item.id
    //           }
    //         })
    //         this.brandOptions.splice(0, this.brandOptions.length, ...brandOptions)
    //       }
    //     })

    //     // 获取分组标签
    //     getGroupCategory().then(res => {
    //       res = res.data
    //       if (res.code === 200) {
    //         this.tagOptions.splice(0, this.tagOptions.length, ...res.data)
    //       }
    //     })
    //   }
    // }
  },
  methods: {
    initStep2() {
      // 获取品牌列表
      getBrand().then(res => {
        res = res.data
        if (res.code === 200) {
          const brandOptions = res.data.map(item => {
            return {
              brandName: item.commonName ? item.commonName : item.brandName,
              brandId: item.brandId ? item.brandId : item.id
            }
          })
          this.brandOptions.splice(0, this.brandOptions.length, ...brandOptions);
          this.form.productBrand = this.brandOptions[0].brandId
        }
      })

      // 获取分组标签
      getGroupCategory().then(res => {
        res = res.data
        if (res.code === 200) {
          this.tagOptions.splice(0, this.tagOptions.length, ...res.data)
        }
      })
    },
    async initData() {
      // if (this.brandOptions && this.brandOptions.length === 0) {
      await getBrand().then(res => {
        res = res.data
        if (res.code === 200) {
          const brandOptions = res.data.map(item => {
            return {
              brandName: item.commonName ? item.commonName : item.brandName,
              brandId: item.brandId ? item.brandId : item.id
            }
          })

          this.brandOptions.splice(0, this.brandOptions.length, ...brandOptions)
        }
      })
      // }
      // if (this.tagOptions && this.tagOptions.length === 0) {
      await getGroupCategory().then(res => {
        res = res.data
        if (res.code === 200) {
          this.tagOptions.splice(0, this.tagOptions.length, ...res.data)
        }
      })
      // }
      // console.log('ssss', this.expandDto)

      let signGroup = []
      if (this.expandDto.signGroup) {
        if (this.expandDto.signGroup.indexOf(',') > -1) {
          signGroup = this.expandDto.signGroup.split(',')
        } else {
          signGroup = [this.expandDto.signGroup]
        }
      }

      const initFormData = {
        productBrand: this.expandDto.productBrand, // 产品品牌
        accessType: this.expandDto.accessType, // 接入类型
        productModel: this.expandDto.productModel, // 产品型号
        signGroup, // 分组标签
        aliases: this.expandDto.aliases, // 别名
        customerPhone: this.expandDto.customerPhone, // 客服电话
        manufacturerName: this.expandDto.manufacturerName, // 制造商名称
        vendorPhone: this.expandDto.vendorPhone, // 供应商电话
        // configNet: this.expandDto.configNet// 配网方式
      }
      
      Object.assign(this.form, initFormData)
      // console.log('ttt', this.form)
      // 初始化文件列表
      let fileItem
      const uploadLlist = []
      // const otherFileList = []
      for (let i = 0; i < this.expandDto.fileLists.length; i++) {
        const item = this.expandDto.fileLists[i]
        if (item.businessType === 3) { // 协议文件
          fileItem = {
            fileId: item.fileId,
            id: new Date().getTime() + Math.random(),
            fileList: [{
              name: item.fileName
            }],
            validate: false,
            fileName: item.fileName,
            fileToken: item.fileToken,
            fileDesc: item.fileDesc,
            businessType: 3// 业务类型(0:ios；1:安卓；2:中控面板；3:协议文件；4:其他)
          }
          uploadLlist.push(fileItem)
        }
      }
      if (uploadLlist.length > 0) {
        this.uploadFileList = uploadLlist
      }

      //  const fileItem = {
      //   id: new Date().getTime() + Math.random(),
      //   fileList: [],
      //   validate: false,
      //   fileName: '',
      //   fileToken: '',
      //   fileDesc: '',
      //   businessType: 3// 业务类型(0:ios；1:安卓；2:中控面板；3:协议文件；4:其他)
      // }
      // this.uploadFileList.push(fileItem)

      // console.log('初始化后：', this.form)
    },
    resetFields() {
      if (this.$refs.ruleForm2) {
        this.$refs.ruleForm2.resetFields()
      }
    },
    addUploadFile() {
      if (this.uploadFileList.length > 4) {
        return
      }
      const fileItem = {
        id: new Date().getTime() + Math.random(),
        fileList: [],
        validate: false,
        fileName: '',
        fileToken: '',
        fileDesc: '',
        businessType: 3// 业务类型(0:ios；1:安卓；2:中控面板；3:协议文件；4:其他)
      }
      this.uploadFileList.push(fileItem)
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    // nextStep(op) { 
    nextStep(op) {
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
            const agreementFile = this.uploadFileList.map(item => {
              const listItem = {
                fileName: item.fileName,
                fileToken: item.fileToken,
                fileDesc: item.fileDesc,
                businessType: 3// 业务类型(0:ios；1:安卓；2:中控面板；3:协议文件；4:其他)
              }
              if (item.fileId) {
                listItem.fileId = item.fileId
              }
              return listItem
            })
            if (this.operate === 'edit') {
              const fileLists = this.expandDto.fileLists.filter(item => {
                return item.businessType.toString() !== '3'
              })
              this.expandDto.fileLists = fileLists.concat(agreementFile)
            } else {
              this.form.agreementFile = agreementFile
            }
            Object.assign(this.expandDto, this.form)
            // 把分组标签数组转为字符串
            if (this.expandDto.signGroup.length === 0) {
              console.log('-------------------------')
              this.expandDto.signGroup = ''
            } else {
              this.expandDto.signGroup = this.expandDto.signGroup.join(',')
            }
            console.log('this.expandDto:', this.expandDto)
            // 验证文件列表是否都通过
            eventBus.$emit('validateFileList')
            let next = true
            for (let i = 0; i < this.uploadFileList.length; i++) {
              console.log('validate:', this.uploadFileList[i].validate)
              if (!this.uploadFileList[i].validate) {
                next = false
                break
              }
            }
            if (!next) {
              return
            }
            if (this.operate === 'update') {
              this.update()
            } else {
              // this.$emit('nextStep', 3)
            }
            resolve(true)
          } else {
            
            resolve(false)
          }
        })
      })
    },
    update() {
      console.log('update---this.expandDto:', this.expandDto)
      const params = Object.assign({}, this.productDetail)
      const expandDto = Object.assign({}, this.expandDto)
      // 删除多余参数
      delete params.expandVo
      if (expandDto && expandDto.agreementFile) {
        delete expandDto.agreementFile
      }
      params.expandDto = expandDto
      console.log('更新的params：', params)
      editProduct({ params: params }).then(
        res => {
          if (res.data.code === 200) {
            this.$message({
              type: 'success',
              message: '产品更新成功'
            })
            this.$emit('delImg')
            this.$emit('closeDialog', 1)
          }
        }
      ).catch(e => {
        const that = this
        setTimeout(function () {
          // 更新失败也重新刷新下详情
          that.$emit('closeDialog', 1)
        }, 500)
      })
    },
    prevStep() {
      this.$emit('prevStep', 1)
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) { // 验证成功
          const addParams = Object.assign({}, this.form)
          if (this.tag === 0) {
            delete addParams.productKey
          }
          console.log(addParams)
          const params = {
            params: addParams
          }
          addProduct(params).then(
            res => {
              if (res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '产品创建成功'
                })
                this.$emit('closeDialog', 1)
              }
            }
          )
        }
      })
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 打开抽屉
    openDrawer(e) {
      this.drawerFlag = true
      this.focusStatus = false
    },
    // 关闭抽屉
    closeDrawer() {
      this.drawerFlag = false
      this.focusStatus = true
    },
    // 获取抽屉传过来的值
    receive(val) {
      console.log('子组件数据', val)
      this.form.categoryName = val.categoryName
      this.form.categoryKey = val.categoryKey
      this.drawerFlag = false
      this.focusStatus = true
    }
  }
}
</script>

<style lang='less' scoped>
.avatar-uploader-icon {
  font-size: 14px;
  color: white;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #409EFF;
  border-radius: 25px;
  cursor: pointer;
}

.el-button {
  margin-left: 10px;
}

.item-row {
  display: flex;

  .item-ele {
    flex: 1;
  }
}
</style>
